import client from './client';

/**
 * Authentication API functions
 * Handles login, registration, logout, and token management
 */
export const authAPI = {
  /**
   * Login with email and password
   * @param {string} email - User email
   * @param {string} password - User password
   * @returns {Promise<{user: Object, access_token: string, refresh_token: string}>}
   */
  login: async (email, password) => {
    const response = await client.post('/auth/login', { email, password });
    return response.data;
  },
  
  /**
   * Register new user account
   * @param {string} name - User name
   * @param {string} email - User email
   * @param {string} password - User password
   * @param {string} userType - User type ('adult' or 'kids')
   * @returns {Promise<{user: Object, access_token: string, refresh_token: string}>}
   */
  register: async (name, email, password, userType = 'adult') => {
    const response = await client.post('/auth/register', {
      name,
      email,
      password,
      user_type: userType
    });
    return response.data;
  },
  
  /**
   * Logout current user
   * Clears all authentication data from storage
   */
  logout: () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user');
    sessionStorage.removeItem('current_user');
  },
  
  /**
   * Guest login - creates temporary guest account
   * @returns {Promise<{user: Object, access_token: string, refresh_token: string}>}
   */
  guestLogin: async () => {
    const response = await client.post('/auth/guest-login');
    return response.data;
  },
  
  /**
   * Refresh access token using refresh token
   * @param {string} refreshToken - Refresh token
   * @returns {Promise<{access_token: string}>}
   */
  refreshToken: async (refreshToken) => {
    const response = await client.post('/auth/refresh', {
      refresh_token: refreshToken
    });
    return response.data;
  },
  
  /**
   * Get current authenticated user information
   * @returns {Promise<Object>} User object with complete profile data
   */
  getCurrentUser: async () => {
    const response = await client.get('/auth/me');
    return response.data;
  }
};
